module.exports = __webpack_public_path__ + "img/home-z-fore.788112ad.png";